var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  null,
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-59fab283\"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Home.de.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/i18n/views/Home.de.vue
// module id = 435
// module chunks = 0